/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251222
*/

'use strict';

import { savePromise } from './ctssJQuery.js';
import { enableBtn } from './ctssVal.js';
import {
    changePWAsync,
    setValidationForConfirmPW,
    setValidationForEditNewPW
} from './snMemberAuthentication.js'
import { getMemberDataAsync } from './snMembers.js';
import {
    redirectToHomeURL,
    setMenu
} from './snSite.js';

const saveMyAccountData = async () => {
    await savePromise({
        url: 'Members',
        data: {
            firstName: $('#editFirstName').val(),
            lastName: $('#editLastName').val(),
            email: $('#editEmail').val(),
            phone: $('#editPhone').val()
        }
    });
    redirectToHomeURL();
}

const initAsync = async () => {
    setMenu();

    try {
        const member = await getMemberDataAsync();
        if (member !== null) {
            $('#editFirstName').val(member.firstName);
            $('#editLastName').val(member.lastName);
            $('#editEmail').val(member.email);
            $('#editPhone').val(member.phone);
        }
    }
    catch (error) { }

    $('#btnCancel').on('click', redirectToHomeURL);
    $('#btnSave').on('click', saveMyAccountData);
    $('#editOldPW').on('input keyup',
        () => enableBtn({
            btnNm: '#btnUpdatePW',
            requiredCtrlNms: ['#editOldPW', '#editOldPW', '#editConfirmPW']
        }));
    $('#editNewPW').on('input keyup',
        () => setValidationForEditNewPW({
            btnNm: '#btnUpdatePW',
            requiredCtrlNms: ['#editOldPW', '#editNewPW', '#editConfirmPW']
        }));

    $('#editConfirmPW').on('input keyup',
        () => setValidationForConfirmPW({ btnNm: '#btnUpdatePW' }));

    $('#btnUpdatePW').on('click', changePWAsync);

};

window.snMyAccount = {
    initAsync
};
